import { render, staticRenderFns } from "./WordOnPic.vue?vue&type=template&id=7d95436d&scoped=true&"
import script from "./WordOnPic.vue?vue&type=script&lang=ts&"
export * from "./WordOnPic.vue?vue&type=script&lang=ts&"
import style0 from "./WordOnPic.vue?vue&type=style&index=0&id=7d95436d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d95436d",
  null
  
)

export default component.exports